/**
 * Matomo — chargé uniquement si activé en base (back-office) et si l'utilisateur
 * accepte les cookies « analytics ».
 */

function normalizeMatomoBaseUrl(url) {
  if (!url) return '';
  return String(url).trim().replace(/\/+$/, '');
}

const defaultRuntimeConfig = { enabled: false, base_url: '', site_id: '' };

let runtimeConfig = { ...defaultRuntimeConfig };

export function setMatomoRuntimeConfig(cfg) {
  const enabled = Boolean(cfg?.enabled);
  const base_url = normalizeMatomoBaseUrl(cfg?.base_url || '');
  const site_id = String(cfg?.site_id || '').trim();
  runtimeConfig = enabled && base_url && site_id
    ? { enabled: true, base_url, site_id }
    : { ...defaultRuntimeConfig };
}

export function getMatomoRuntimeConfig() {
  return { ...runtimeConfig };
}

export function isMatomoConfigured() {
  return Boolean(runtimeConfig.enabled && runtimeConfig.base_url && runtimeConfig.site_id);
}

export function getMatomoSiteDomain() {
  if (typeof window === 'undefined') return 'wownautic.com';
  return window.location.hostname || 'wownautic.com';
}

export function getMatomoCookieTableBody(domain = getMatomoSiteDomain()) {
  return [
    {
      name: '_pk_id.*',
      domain,
      description: 'Matomo — identifiant visiteur (anonymisé)',
      expiration: '13 mois',
    },
    {
      name: '_pk_ses.*',
      domain,
      description: 'Matomo — session de visite',
      expiration: '30 min',
    },
    {
      name: '_pk_ref.*',
      domain,
      description: 'Matomo — site référent',
      expiration: '6 mois',
    },
  ];
}

let matomoLoaded = false;

export function isMatomoActive() {
  return matomoLoaded && typeof window !== 'undefined' && Array.isArray(window._paq);
}

export function initMatomo() {
  if (typeof window === 'undefined' || matomoLoaded || !isMatomoConfigured()) return false;

  const baseUrl = runtimeConfig.base_url;
  const siteId = runtimeConfig.site_id;
  const trackerUrl = `${baseUrl}/matomo.php`;

  window._paq = window._paq || [];
  window._paq.push(['setTrackerUrl', trackerUrl]);
  window._paq.push(['setSiteId', siteId]);
  window._paq.push(['enableLinkTracking']);

  const script = document.createElement('script');
  script.async = true;
  script.src = `${baseUrl}/matomo.js`;
  script.setAttribute('data-matomo', 'wownautic');
  document.head.appendChild(script);

  matomoLoaded = true;
  return true;
}

export function disableMatomo() {
  if (typeof window === 'undefined') return;
  if (Array.isArray(window._paq)) {
    window._paq.push(['forgetConsentGiven']);
    window._paq.push(['optUserOut']);
  }
  document.querySelectorAll('script[data-matomo="wownautic"]').forEach((el) => el.remove());
  matomoLoaded = false;
}

export function syncMatomoWithConsent(acceptedAnalytics) {
  if (!isMatomoConfigured()) return;
  if (acceptedAnalytics) {
    initMatomo();
    trackMatomoPageView();
  } else {
    disableMatomo();
  }
}

export function trackMatomoPageView(pathname, documentTitle) {
  if (!isMatomoActive()) return;
  const path = pathname || window.location.pathname + window.location.search;
  const title = documentTitle || document.title;
  window._paq.push(['setCustomUrl', path]);
  window._paq.push(['setDocumentTitle', title]);
  window._paq.push(['trackPageView']);
}
